export default __webpack_public_path__ + "static/media/2-1-4.21b3b06b.webp";